import { FC } from 'react';

interface ShoppingProductMobileProps {
  title: string;
  icon: React.ReactElement;
  details: React.ReactElement;
  pricing: React.ReactElement;
  bottomContent?: React.ReactElement;
}

export const ShoppingItemMobile: FC<ShoppingProductMobileProps> = ({
  title,
  icon,
  details,
  pricing,
  bottomContent,
}) => {
  return (
    <div className="flex flex-row items-center mb-4">
      <div className="grow pl-6 pr-4 py-3.5 rounded-lg bg-white border border-sami-card-border shadow hover:shadow-md">
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-col pr-2.5">
            <div style={{ hyphens: 'auto' }} className="text-sm font-bold leading-tight text-text-dark">
              {title}
            </div>
            {details}
          </div>

          <div className="flex flex-col">
            <div className="flex flex-col items-end">{icon}</div>
            {pricing}
          </div>
        </div>
        {bottomContent}
      </div>
    </div>
  );
};
